import React from 'react';
import { BaseComponent } from '../../../../components/BaseComponent';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { FormField } from '../../../../components/FormFields';
import { Input } from '../../../../components/Input';
import { Dropdown } from '../../../../components/Dropdown';
import { HBox, VBox } from '../../../../components/Box';
import { Button } from '../../../../components/Buttons';
import { ModalControls } from '../../../../components/Modal';
import { Checkbox } from '../../../../components/Checkbox';
import { COLOR_PRIMARY_1 } from '../../../../vars';
import { Left } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';

const Container = styled.div`
  width: 94%;
  height: 100vh;
  position: fixed;
  left: 12px;
  background-color: #fff;
  z-index: 100000;
  overflow: auto;

  .field-block {
    margin-bottom: 8px;
    justify-content: center;
    white-space: nowrap;
    .label {
      width: 60%;
    }
  }

  .checkbox-wrapper {
    strong {
      font-weight: 500;
    }

    .check-field {
      margin-bottom: 10px;
    }
  }

  .modal-top {
    z-index: 20;
    position: fixed;
    left: ${props => (props.innerWidth <= 768 ? '0px' : '')};
    // top: 163px;
    width: 100%;
    height: 90px;
    padding: 15px;
    font-weight: 600;

    background-color: ${COLOR_PRIMARY_1};
    color: #fff;
  }
  .modal-body {
    overflow: auto;
    max-height: ${props => (props.innerHeight <= 500 ? '45vh' : '60vh')};
    position: relative;
    top: 100px;
    padding: 12px;
    padding-bottom: 25%;
    background-color: #fff;
  }

  .mobile-btn-block {
    position: fixed;
    left: 0;
    bottom: 0;
    margin: 0;
    width: 100%;
    .modal-footer-button {
      margin: 0;
      display: flex;
      height: 70px;
      min-width: 50%;
    }
  }
`;

const STATE = {
  string: null,
  result: null,
};

/* eslint-disable react/prefer-stateless-function */
class UserQuickCreatorMobileModalComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  save() {
    this.props.onSave();
  }

  reset() {
    this.props.onCancel();
  }

  onUserInputChange(evt) {
    const { name, value } = evt.target;
    this.props.setUser(name, value);
  }

  onCheckRole(role) {
    this.props.setRole(role);
  }

  render() {
    return (
      <Container innerHeight={window.innerHeight} innerWidth={window.innerWidth}>
        <HBox vCenter left className="modal-top" onClick={() => this.reset()}>
          <Left /> {this.lbl('company.details.create_user')}
        </HBox>
        <VBox top className="modal-body">
          <HBox vCenter className="field-block">
            <FormField>
              <Input
                placeholder={this.lblStr('user.details.name')}
                name="name"
                value={this.props.newUser?.name ?? ''}
                onChange={this.onUserInputChange.bind(this)}
                style={{ minWidth: '300px' }}
              />
            </FormField>
          </HBox>
          <HBox vCenter className="field-block">
            <FormField>
              <Input
                name="surname"
                value={this.props.newUser?.surname ?? ''}
                placeholder={this.lblStr('user.details.surname')}
                onChange={this.onUserInputChange.bind(this)}
                style={{ minWidth: '300px' }}
              />
            </FormField>
          </HBox>

          <HBox vCenter className="field-block">
            <FormField>
              <Input
                name="email_address"
                value={this.props.newUser?.email_address ?? ''}
                placeholder={this.lblStr('user.details.email_address')}
                onChange={this.onUserInputChange.bind(this)}
                style={{ minWidth: '300px' }}
              />
            </FormField>
          </HBox>

          <HBox vCenter className="field-block">
            <FormField>
              <Input
                name="phone"
                value={this.props.newUser?.phone ?? ''}
                placeholder={this.lblStr('user.details.phone')}
                onChange={this.onUserInputChange.bind(this)}
                style={{ minWidth: '300px' }}
              />
            </FormField>
          </HBox>
          {/* <VBox className="field-block">
            <strong className="label" style={{ marginBottom: '10px' }}>
              {this.lbl('user.create.modal.type_of_contact')}
            </strong>
            <VBox className="checkbox-wrapper">
              <FormField className="check-field">
                <Checkbox
                  checked={this.props.roles?.financial_contact == '1'}
                  onChange={() => this.onCheckRole('financial_contact')}
                >
                  <strong>{this.lbl('company.users.role.financial_contact')}</strong>
                </Checkbox>
              </FormField>
              <FormField className="check-field">
                <Checkbox
                  checked={this.props.roles?.commercial_contact == '1'}
                  onChange={() => this.onCheckRole('commercial_contact')}
                >
                  <strong>{this.lbl('company.users.role.commercial_contact')}</strong>
                </Checkbox>
              </FormField>
              <FormField className="check-field">
                <Checkbox
                  checked={this.props.roles?.document_contact == '1'}
                  onChange={() => this.onCheckRole('document_contact')}
                >
                  <strong>{this.lbl('company.users.role.document_contact')}</strong>
                </Checkbox>
              </FormField>
            </VBox>
          </VBox> */}
          <ModalControls className="mobile-btn-block">
            <Button select className="modal-footer-button" onClick={this.reset.bind(this)}>
              {this.lbl(`cancel`)}
            </Button>
            <Button
              disabled={!this.props.newUser?.email_address || this.props.workCreate}
              className="modal-footer-button"
              onClick={this.save.bind(this)}
            >
              {this.props.workCreate ? <Loader small /> : this.lbl(`confirm`)}
            </Button>
          </ModalControls>
        </VBox>
      </Container>
    );
  }
}

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const UserQuickCreatorMobileModal = compose(withConnect, withRouter, injectIntl)(UserQuickCreatorMobileModalComp);
